import NotificationAdvancedView from './NotificationAdvancedView'

export default NotificationAdvancedView
